<template>
    <fieldset id="public-filter" v-if="user.is_staff">
        <legend>Offentlig: </legend>
        <input
            type="radio"
            id="public-yes"
            name="ispublic"
            :value="true"
            @change="emitChange()"
            v-model="is_public">
        <label for="public-yes">Ja</label>
        <input
            type="radio"
            id="public-no"
            name="ispublic"
            :value="false"
            @change="emitChange()"
            v-model="is_public">
        <label for="public-no">Nej</label>
    </fieldset>
</template>

<script>

    export default {
        data: function() {
            return {
                is_public: ''
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            }
        },
        methods: {
            emitChange: function(value) {
                this.$emit('filter', { 'is_public': this.is_public })
            }
        }
    }
</script>

<style lang="scss">

    #public-filter {
        label {
            padding: 0 .75rem 0 .25rem;
        }
    }

</style>